module.exports = __webpack_public_path__ + "media/images/soar/site/insta-15a473e3cf2d1096461299b090056806.svg";